import RolesPrivilegesManager from './RolesPrivilegesManager'
export default RolesPrivilegesManager
